/**
 * VERZONNEN demo-data voor Frits (tests + ?demo=1 op localhost). Alle namen,
 * bedrijven, adressen en bedragen zijn verzonnen — geen echte mail of klant.
 */

const opTijd = (nu, dagenTerug, uur, minuut) => {
  const d = new Date(nu);
  d.setDate(d.getDate() - dagenTerug);
  d.setHours(uur, minuut, 0, 0);
  return d.toISOString();
};

export function maakDemoMails(nu = new Date()) {
  const ronde = opTijd(nu, 0, 7, 30);
  const basis = {
    to_recipients: ['demo@fullframe.nl'], cc_recipients: [], web_link: null, draft_created: false,
    draft_message_id: null, project_match: null, scope_warning: null, already_replied: null,
    is_meeting_request: false, status: 'open', created_at: ronde, conversation_id: null,
  };
  return [
    {
      ...basis, id: 9001, message_id: 'demo-1',
      subject: 'Offerteaanvraag animatie jaarverslag', from_name: 'Marloes Vink', from_email: 'marloes@vinkenhout.example',
      received_at: opTijd(nu, 0, 6, 48), priority: 'hoog', category: 'offerte', needs_reply: true,
      summary: 'Marloes van Vinkenhout vraagt een offerte voor een animatie van 90 seconden bij hun jaarverslag. Oplevering uiterlijk 14 november; ze wil vóór vrijdag een prijsindicatie.',
      prio_reason: 'Klant vraagt om een prijsindicatie met een harde deadline.',
      concept: 'Dag Marloes,\n\nDank voor de aanvraag. Ik zet de opties voor de animatie op een rij en stuur je donderdag een prijsindicatie, zodat jullie vrijdag kunnen beslissen.\n\nGroet,\nDemo',
      suggested_actions: [
        { type: 'offerte', label: 'Offerte opstellen' },
        { type: 'todo', label: 'Briefing doorlezen' },
      ],
      project_match: { project_number: '4410', project_name: 'Vinkenhout jaarverslag', confidence: 0.8, match_source: 'klant' },
    },
    {
      ...basis, id: 9002, message_id: 'demo-2',
      subject: 'Feedbackronde versie 2 — productfilm', from_name: 'Timo Brakel', from_email: 'timo@hoeksteen-bouw.example',
      received_at: opTijd(nu, 0, 8, 5), priority: 'normaal', category: 'beantwoorden', needs_reply: true,
      summary: 'Timo heeft drie opmerkingen op versie 2: logo later in beeld, muziek iets zachter en een andere eindtitel. Verder akkoord.',
      prio_reason: 'Feedback op lopende productie; niet urgent.',
      concept: 'Hoi Timo,\n\nHelder, dank je. We passen de drie punten aan en sturen maandag versie 3.\n\nGroet,\nDemo',
      suggested_actions: [{ type: 'todo', label: 'Feedback v2 verwerken' }],
      cc_recipients: ['demo@fullframe.nl'],
    },
    {
      ...basis, id: 9003, message_id: 'demo-3',
      subject: 'Kunnen we dinsdag even bellen over de draaidag?', from_name: 'Sanne de Wilde', from_email: 'sanne@fullframe.nl',
      received_at: opTijd(nu, 0, 9, 12), priority: 'normaal', category: 'planning', needs_reply: true,
      summary: 'Sanne stelt dinsdag tussen 10:00 en 12:00 voor om de draaidag bij Korenmolen te bespreken.',
      prio_reason: 'Interne afstemming voor een productie deze maand.',
      concept: 'Yo Sanne,\n\nDinsdag 10:30 kan ik. Zet jij hem in de agenda?\n\nDemo',
      suggested_actions: [{ type: 'planner', label: 'Planner informeren' }],
    },
    {
      ...basis, id: 9004, message_id: 'demo-4',
      subject: 'Graag een taak: ondertitels Engels', from_name: 'Pieter Laan', from_email: 'pieter@fullframe.nl',
      received_at: opTijd(nu, 1, 16, 40), priority: 'laag', category: 'taak', needs_reply: false,
      summary: 'Pieter vraagt of iemand de Engelse ondertitels voor de onboardingfilm kan maken, uiterlijk volgende week.',
      prio_reason: 'Interne taak met ruime deadline.',
      concept: null, taak_voor: 'team',
      suggested_actions: [{ type: 'todo', label: 'Ondertitels Engels maken' }],
    },
    {
      ...basis, id: 9005, message_id: 'demo-5',
      subject: 'Akkoord op offerte 4398', from_name: 'Ilse Kramer', from_email: 'ilse@rivierzorg.example',
      received_at: opTijd(nu, 1, 11, 20), priority: 'hoog', category: 'offerte', needs_reply: true,
      summary: 'Ilse geeft akkoord op offerte 4398 voor de wervingsfilm en vraagt wanneer de eerste draaidag kan zijn.',
      prio_reason: 'Akkoord van de klant: offerte omzetten en planning starten.',
      concept: 'Dag Ilse,\n\nFijn, dank je! Ik stuur je morgen twee opties voor de draaidag.\n\nGroet,\nDemo',
      suggested_actions: [
        { type: 'offerte', label: 'Offerte omzetten naar opdracht' },
        { type: 'planner', label: 'Draaidag inplannen' },
        { type: 'todo', label: 'Kick-off voorbereiden' },
        { type: 'factuur', label: 'Aanbetaling factureren' },
      ],
    },
    {
      ...basis, id: 9006, message_id: 'demo-6',
      subject: 'Nieuwe huisstijl gedeeld', from_name: 'Koen Aalberts', from_email: 'koen@dijkgraaf-energie.example',
      received_at: opTijd(nu, 0, 7, 2), priority: 'normaal', category: 'fyi', needs_reply: false,
      summary: 'Koen deelt de nieuwe huisstijlhandleiding van Dijkgraaf Energie ter info voor toekomstige producties.',
      prio_reason: 'Alleen ter info.', concept: null, suggested_actions: [],
    },
    {
      ...basis, id: 9007, message_id: 'demo-7',
      subject: 'Maandoverzicht september', from_name: 'Beeldbank Nieuws', from_email: 'nieuws@beeldbank.example',
      received_at: opTijd(nu, 2, 6, 0), priority: 'laag', category: 'nieuwsbrief', needs_reply: false,
      summary: 'Nieuwsbrief met nieuwe stockbeelden en een korting op jaarlicenties.',
      prio_reason: 'Nieuwsbrief.', concept: null, suggested_actions: [],
    },
    {
      ...basis, id: 9008, message_id: 'demo-8',
      subject: 'Factuur 2026-118 geluidsmix', from_name: 'Studio Echoput', from_email: 'administratie@echoput.example',
      received_at: opTijd(nu, 0, 5, 55), priority: 'normaal', category: 'fyi', needs_reply: false,
      summary: 'Factuur voor de geluidsmix van de productfilm, € 640 excl. btw, met opdrachtnummer 4402.',
      prio_reason: 'Inkoopfactuur; controleren en doorsturen.', concept: null, suggested_actions: [],
    },
  ];
}

export function maakDemoReminders() {
  return [
    { number: '4391', gripp_id: 1, subject: 'Explainer nieuwe klantportal', company_name: 'Kade Verzekeringen', contact_name: 'Ruben Mol', days_open: 8, total_excl: 780000 },
    { number: '4387', gripp_id: 2, subject: 'Social cutdowns voorjaarscampagne', company_name: 'Bosrand Retail', contact_name: 'Eva Smit', days_open: 12, total_excl: 325000 },
    { number: '4380', gripp_id: 3, subject: 'Recruitmentfilm monteurs', company_name: 'Tromp Installatie', contact_name: 'Joost Tromp', days_open: 15, total_excl: 1190000 },
    { number: '4376', gripp_id: 4, subject: 'Animatie veiligheidsinstructie', company_name: 'Havenbedrijf Noordkaap', contact_name: 'Lotte Brink', days_open: 19, total_excl: 460000 },
    { number: '4369', gripp_id: 5, subject: 'Jubileumfilm 50 jaar', company_name: 'Coöperatie De Eik', contact_name: '', days_open: 24, total_excl: 0 },
  ];
}
